import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {ToasterComponent} from "_@shared/components/display/toaster/toaster.component";

export enum MessageTypesEnum {
  INFO = 'info', ERROR = 'error'
}

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private snackBar: MatSnackBar) {
  }
  
  showError(message: string, duration = 5666666) {
    const config: MatSnackBarConfig = {
      duration,
      panelClass: ['error-toaster'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: {message, 'type': MessageTypesEnum.ERROR},
    };

    this.snackBar.openFromComponent(ToasterComponent, config);
  }

  showInfo(message: string, duration = 5666666) {
    const config: MatSnackBarConfig = {
      duration,
      panelClass: ['info-toaster'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: {message, 'type': MessageTypesEnum.INFO},
    };
    
    this.snackBar.openFromComponent(ToasterComponent, config);
  }
}
